/** Canonical marketing paths for funnel nav links (SPA + native href fallbacks). */
export const MARKETING_VIEW_PATHS: Record<string, string> = {
  home: '/',
  business: '/business',
  'job-board': '/job-board',
  'success-stories': '/success-stories',
  'features-overview': '/features',
  problem: '/problem',
  'who-its-for': '/who-its-for',
  'feature-resume-optimizer': '/features/resume-optimizer',
  'feature-smart-matching': '/features/smart-matching',
  'feature-interview-prep': '/features/interview-prep',
  'resume-check': '/resume-check',
  login: '/login',
  signup: '/signup',
  pricing: '/pricing',
  blog: '/blog',
  careers: '/careers',
  'contact-us': '/contact-us',
  'about-us': '/about-us',
};

export function marketingPathForView(view: string): string {
  return MARKETING_VIEW_PATHS[view] ?? '/';
}
